import { withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiTextareaAutosize from '@material-ui/core/TextareaAutosize';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import * as API from 'api';
import { useMutation } from 'react-query';
import MuiTextField from '@material-ui/core/TextField';

const QueryLibrary = API.QueryLibrary();

const styles = theme => ({
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
  title: {
    width: '100%',
    marginBottom: '10px',
  },
  textArea: {
    width: '100%',
    minHeight: '100px',
  },
});

const CreateQuery = ({ refetch, ...props }) => {
  const { classes } = props;
  const [open, setOpen] = useState(false);
  const formMethods = useForm({
    defaultValues: {
      title: '',
      prompt: '',
    },
  });

  const createQuery = useMutation(({ title, prompt }) => QueryLibrary.createQueryLibraryPrompt({ title, prompt }), {
    onSuccess: () => {
      formMethods.reset();
      handleClose();
      refetch();
    },
    onError: error => {
      alert(error.data?.message || 'Unknown Error');
      createQuery.reset();
    },
  });

  function handleClick() {
    setOpen(true);
  }
  function handleClose() {
    setOpen(false);
  }
  function handleSubmit(data) {
    const { title, prompt } = data;
    createQuery.mutate({ title, prompt });
  }

  return (
    <>
      <MuiButton variant="contained" size="small" startIcon={<AddIcon />} onClick={handleClick}>
        New query
      </MuiButton>
      <MuiDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <MuiDialogTitle id="form-dialog-title">Create new query</MuiDialogTitle>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <MuiDialogContent>
            <MuiTextField
              className={classes.title}
              label="Title"
              name="title"
              value={formMethods.watch('title')}
              onChange={e => formMethods.setValue('title', e.target.value)}
              {...formMethods.register('title')}
            />
            <MuiTextareaAutosize
              className={classes.textArea}
              label="Query"
              name="prompt"
              value={formMethods.watch('prompt')}
              onChange={e => formMethods.setValue('prompt', e.target.value)}
              {...formMethods.register('prompt')}
            />
          </MuiDialogContent>
          <MuiDialogActions className={classes.dialogFooter}>
            <MuiButton variant="contained" onClick={handleClose}>
              Cancel
            </MuiButton>
            <MuiButton
              variant="contained"
              color="primary"
              type="submit"
              disabled={!formMethods.watch('prompt') || !formMethods.watch('title') || createQuery.isLoading}>
              {createQuery.isLoading ? 'Creating...' : 'Create query'}
            </MuiButton>
          </MuiDialogActions>
        </form>
      </MuiDialog>
    </>
  );
};

export default withStyles(styles)(CreateQuery);
